import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals'
import type { Tracker } from './tracker'

export interface WebVitalsConfig {
  tracker?: Tracker
  reportToConsole?: boolean
  reportToAnalytics?: boolean
  onMetric?: (metric: Metric) => void
  debug?: boolean
}

const defaultConfig: WebVitalsConfig = {
  reportToConsole: true,
  reportToAnalytics: true,
  debug: false,
}

export function initWebVitals(config: WebVitalsConfig = {}) {
  const finalConfig = { ...defaultConfig, ...config }
  const handleMetric = (metric: Metric) => {
    const rating = getRating(metric)
    if (finalConfig.reportToConsole) logMetricToConsole(metric, rating)
    if (finalConfig.reportToAnalytics && finalConfig.tracker) {
      finalConfig.tracker.track('web-vital-measured' as any, {
        v: 1,
        metric: metric.name,
        value: Math.round(metric.value),
        rating,
        id: metric.id,
        navigationType: (metric as any).navigationType,
      } as any)
      finalConfig.tracker.track(`web-vital-${metric.name.toLowerCase()}` as any, {
        v: 1,
        value: Math.round(metric.value),
        rating,
        navigationType: (metric as any).navigationType,
      } as any)
    }
    finalConfig.onMetric?.(metric)
    if (finalConfig.debug) console.log('[WebVitals]', metric)
  }
  onCLS(handleMetric); onFCP(handleMetric); onINP(handleMetric); onLCP(handleMetric); onTTFB(handleMetric)
}

function getRating(metric: Metric): 'good' | 'needs-improvement' | 'poor' {
  const thresholds: Record<string, [number, number]> = { LCP: [2500, 4000], FID: [100,300], CLS: [0.1,0.25], FCP:[1800,3000], TTFB:[800,1800], INP:[200,500] }
  const [good, poor] = thresholds[metric.name] || [0, Infinity]
  const v = metric.value
  if (v <= good) return 'good'; if (v <= poor) return 'needs-improvement'; return 'poor'
}

function logMetricToConsole(metric: Metric, rating: 'good' | 'needs-improvement' | 'poor') {
  const colors = { good: 'color:#10b981;font-weight:bold;', 'needs-improvement': 'color:#f59e0b;font-weight:bold;', poor: 'color:#ef4444;font-weight:bold;' }
  const emoji = { good: '✅', 'needs-improvement': '⚠️', poor: '❌' }
  // eslint-disable-next-line no-console
  console.log(`%c${emoji[rating]} ${metric.name}: ${Math.round(metric.value)}${metric.name==='CLS'?'':'ms'}`, colors[rating])
}

export function getWebVitalsSummary(): Promise<Record<string, number>> {
  return new Promise((resolve) => {
    const metrics: Record<string, number> = {}
    let count = 0
    const total = 5
    const done = () => { count++; if (count >= total) resolve(metrics) }
    onCLS((m)=>{ metrics.CLS=m.value; done() })
    onFCP((m)=>{ metrics.FCP=m.value; done() })
    onINP((m)=>{ metrics.INP=m.value; done() })
    onLCP((m)=>{ metrics.LCP=m.value; done() })
    onTTFB((m)=>{ metrics.TTFB=m.value; done() })
    setTimeout(()=>resolve(metrics), 10000)
  })
}

